import styled from 'styled-components';

interface SuperScriptProps {
  color?: 'seedgreen' | 'snowwhite';
  top?: string;
  fontSize?: string;
  lineHeight?: string | number;
  paddingRight?: string;
  position?: 'relative' | 'absolute' | 'fixed' | 'sticky' | 'static';
  verticalAlign?: string;
}

const StyledSuperScript = styled.sup<SuperScriptProps>`
  color: ${(props) =>
    props.color ? `var(--color--${props.color})` : 'currentColor'};
  ${(props) => props.top !== undefined && `top: ${props.top};`}
  ${(props) => props.fontSize !== undefined && `font-size: ${props.fontSize};`}
  ${(props) =>
    props.lineHeight !== undefined && `line-height: ${props.lineHeight};`}
  ${(props) => props.position !== undefined && `position: ${props.position};`}
  ${(props) =>
    props.verticalAlign !== undefined &&
    `vertical-align: ${props.verticalAlign};`}
  ${(props) =>
    props.paddingRight !== undefined && `padding-right: ${props.paddingRight};`}
`;

interface SuperScriptTextProps extends SuperScriptProps {
  text: string;
}

const SuperScriptText = ({
  text,
  color,
  top,
  fontSize,
  lineHeight,
  position,
  verticalAlign,
  paddingRight,
}: SuperScriptTextProps) => {
  return (
    <StyledSuperScript
      color={color}
      top={top}
      fontSize={fontSize}
      lineHeight={lineHeight}
      position={position}
      verticalAlign={verticalAlign}
      paddingRight={paddingRight}
    >
      {text}
    </StyledSuperScript>
  );
};

export default SuperScriptText;
